export default __webpack_public_path__ + "static/media/silver-package.ee787081.png";